import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wizard-step"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.isVisible)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_Card, { title: _ctx.title }, _createSlots({
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 2
        }, [
          (_ctx.$slots.header)
            ? {
                name: "header",
                fn: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "header")
                ])
              }
            : undefined,
          (_ctx.navigation)
            ? {
                name: "footer",
                fn: _withCtx(() => [
                  (_ctx.$slots.footer)
                    ? _renderSlot(_ctx.$slots, "footer", { key: 0 })
                    : (_openBlock(), _createBlock(_component_Navigation, { key: 1 }))
                ])
              }
            : undefined
        ]), 1032, ["title"])
      ]))
    : _createCommentVNode("", true)
}